import { fetchCurrentUser } from '../../ducks/user.duck';
import { onFindGroupJoinRequestCollection, onGroupFolderDocumentCollectionCreate } from '../../util/api';
import { storableError } from '../../util/errors';
import { GROUP_PAYMENT_STATUS_ACTIVE } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import { fetchAdminModerator } from '../AdminPanelModeratorsPage/AdminPanelModeratorsPage.duck';
import { fetchSpaceList, getCurrentUserCircleAuthParams, getSpaceDetails, requestSpaceDetails, setInitalLoadToken, toggleCreateComment } from '../CircleCommunityPage/CircleCommunityPage.duck';
import { fetchGroupFolder, fetchGroupPayment } from '../MyGroupCommunityPage/MyGroupCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/DiscoverGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/DiscoverGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/DiscoverGroupPage/ERROR_SPACE_DETAILS';

export const REQUEST_UPDATE_DOCUMENT = 'app/DiscoverGroupPage/REQUEST_UPDATE_DOCUMENT';
export const SUCCESS_UPDATE_DOCUMENT = 'app/DiscoverGroupPage/SUCCESS_UPDATE_DOCUMENT';
export const ERROR_UPDATE_DOCUMENT = 'app/DiscoverGroupPage/ERROR_UPDATE_DOCUMENT';

export const FIND_GROUP_JOIN_REQUEST = 'app/DiscoverGroupPage/FIND_GROUP_JOIN_REQUEST';
export const FIND_GROUP_JOIN_SUCCESS = 'app/DiscoverGroupPage/FIND_GROUP_JOIN_SUCCESS';
export const FIND_GROUP_JOIN_ERROR = 'app/DiscoverGroupPage/FIND_GROUP_JOIN_ERROR';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,

  updateDocumentInProgress: false,
  documnetUpdated: null,
  updateDocumentError: null,

  groupJoinRequests: null,
  groupJoinProgress: false,
  groupJoinError: false,

};

export default function DiscoverGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case REQUEST_UPDATE_DOCUMENT:
      return { ...state, updateDocumentInProgress: true };
    case SUCCESS_UPDATE_DOCUMENT:
      return { ...state, updateDocumentInProgress: false, documnetUpdated: payload.data };
    case ERROR_UPDATE_DOCUMENT:
      return {
        ...state,
        updateDocumentInProgress: false,
        documnetUpdated: null,
        updateDocumentError: payload.error,
      };

    case FIND_GROUP_JOIN_REQUEST:
      return {
        ...state,
        groupJoinRequests: null,
        groupJoinProgress: true,
        groupJoinError: false
      };
    case FIND_GROUP_JOIN_SUCCESS:
      return {
        ...state,
        groupJoinRequests: payload,
        groupJoinProgress: false,
        groupJoinError: false
      };
    case FIND_GROUP_JOIN_ERROR:
      return {
        ...state,
        groupJoinRequests: null,
        groupJoinProgress: false,
        groupJoinError: true
      };

    default:
      return state;
  }
}

// export const requestSpaceDetails = () => ({
//   type: REQUEST_SPACE_DETAILS,
// });
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const requestUpdateDocument = () => ({
  type: REQUEST_UPDATE_DOCUMENT,
});
export const successUpdateDocument = data => ({
  type: SUCCESS_UPDATE_DOCUMENT,
  payload: { data },
});
export const errorUpdateDocument = error => ({
  type: ERROR_UPDATE_DOCUMENT,
  payload: { error },
});

export const findGroupJoinRequest = () => ({
  type: FIND_GROUP_JOIN_REQUEST,
});
export const findGroupJoinSuccess = data => ({
  type: FIND_GROUP_JOIN_SUCCESS,
  payload: data,
});
export const findGroupJoinError = error => ({
  type: FIND_GROUP_JOIN_ERROR,
  payload: { error },
});


export const uploadDocumentInMongo = params => (dispatch, getState) => {
  dispatch(requestUpdateDocument());
  return onGroupFolderDocumentCollectionCreate({ payload: params }).then((res) => {
    dispatch(successUpdateDocument(res));
    return res;
  })
    .catch((error) => {
      dispatch(errorUpdateDocument(storableError(error)));
    })
};

export const findGroupJoin = params => (dispatch, getState) => {
  dispatch(findGroupJoinRequest());
  return onFindGroupJoinRequestCollection(params)
    .then((res) => {
      dispatch(findGroupJoinSuccess(res));
      return res;
    })
    .catch((error) => {
      console.error(error, '&&& &&& => error');
      dispatch(findGroupJoinError(storableError(error)));
    })
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1, sort = 'latest', topicId = null } = parse(search);

  dispatch(requestSpaceDetails(page));

  return Promise.all([dispatch(fetchCurrentUser())])
    .then(async response => {
      // Get the current user's data from state
      const currentUser = getState().user.currentUser;
      const email = currentUser?.attributes?.email;

      const { spaceListData } = getState().CircleCommunityPage;

      if (email) {
        // fetch auth token on first load
        await setInitalLoadToken(getCurrentUserCircleAuthParams(currentUser))
        // Fetch Circle auth token with pagination
        const promisify = [
          dispatch(getSpaceDetails({ spaceId: params.id, page: +page, sort, topicId: topicId })),
          dispatch(toggleCreateComment(false)),
          dispatch(fetchGroupFolder({
            payload: {
              groupId: params.id,
              isActive: true,
              isDelete: false
            }
          })),

          dispatch(findGroupJoin({
            email,
            spaceId: params.id
          }))

        ];

 // ✅ Fetch Admin and Moderator
        dispatch(fetchAdminModerator({
          payload: {
            groupId: params.id,
            status: 'active',
            role: 'admin',
          },
        }));
        dispatch(fetchGroupPayment({
          payload: {
            groupId: params.id,
            status: GROUP_PAYMENT_STATUS_ACTIVE,
          },
          pageParams: {
            page: 1,
            perPage: 1,
          }
        }));

        if (!spaceListData || (spaceListData && spaceListData.length == 0)) promisify.push(dispatch(fetchSpaceList()));

        return Promise.all(promisify);
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};
